import { MoonLoader } from 'react-spinners'
import { CardExecutor } from '../../CardsComponents/CardExecutor/CardExecutor'
import { useState, useEffect } from 'react'
import { InputDinamycPlaceholder, ButtonBasic, Tabs } from "@lk-gtcom/ecomlab-components"
import { TextPage } from '../../TextPage/TextPage'
import { TitlePage } from '../../TitlePage/TitlePage'
import { ModalComponent } from '../ModalComponent/ModalComponent'
import './ModalCreateGroup.scss'


const ModalCreateGroup = ({
    status,
    setIsModal,
    createGroup,
    createChat,
    type,
    usersList,
    currentMessage,
    isEdit,
    setIsEdit,
    editGroup,
    fetchAddUsers,
    fetchDeleteUsers,
    fetchUsers
}) => {
    const [load, setLoad] = useState(false)
    const [nameGroup, setGroupName] = useState('')
    const id_members = currentMessage?.members?.map((el) => el.id)
    const [selectedUsers, setSelectedUsers] = useState(isEdit ? id_members : [])

    useEffect(() => {
        if (isEdit) {
            setGroupName(currentMessage?.name)
        }
    }, [isEdit]);

    return (
        <ModalComponent
            title={type ?
                (isEdit ? 'Редактирование чата' : 'Создание чата')
                :
                (isEdit ? 'Редактирование группы' : 'Создание группы')}
            style={{ maxWidth: '880px' }}
            loading={load}
            isNoData={!usersList?.length}
            onClose={(e) => {
                setIsEdit(false)
                setIsModal(false)
            }}
            child={
                <div className='modal-сreate-group'>
                    {!type &&
                        <InputDinamycPlaceholder
                            value={nameGroup}
                            required
                            changeValue={isEdit ? currentMessage?.name : ''}
                            onChange={(e) => setGroupName(e)}
                            placeholder={type ? 'Название чата' : 'Название группы'}
                            size='s'
                        />}

                    <div className='modal-сreate-group__content'>
                        {usersList?.map((props, i) => {
                            const id = props?.id
                            if (!props?.available_to_personal && type) {
                                return null
                            } else {
                                return <CardExecutor
                                    key={id}
                                    {...props}
                                    color={props?.color}
                                    status={selectedUsers?.indexOf(id) >= 0}
                                    addNewMember={(e) => {
                                        if (type) {
                                            // Добавление чата
                                            createChat(id)
                                            setTimeout(() => fetchUsers(), 1000)
                                            setIsModal(false)
                                            e.stopPropagation()
                                        } else {
                                            if (selectedUsers?.indexOf(id) !== -1) {
                                                setSelectedUsers(prev => prev?.filter(el => el !== id))
                                                if (isEdit) {
                                                    fetchDeleteUsers(currentMessage?.chat?.chat_id, id)
                                                }
                                            } else {
                                                setSelectedUsers(prev => [...prev, id])
                                                // добавляем участника приредактировании
                                                if (isEdit) {
                                                    fetchAddUsers(currentMessage?.chat?.chat_id, id)
                                                }
                                            }
                                        }
                                    }} />
                            }
                        })}
                    </div>

                    {!type && 
                        <ButtonBasic
                            green
                            width='260px'
                            text='Сохранить'
                            size='56px'
                            disabled={!type && !nameGroup}
                            onClick={e => {
                                if (isEdit) {
                                    editGroup(currentMessage?.chat?.chat_id, nameGroup)
                                } else {
                                    createGroup(selectedUsers, nameGroup)
                                }
                                setIsEdit(false)
                                setIsModal(false)
                            }}
                        />}
                </div>
            }
        />
    )
}

export { ModalCreateGroup }